import _ from 'lodash';

// TODO: remove and replace with ES implemetation
// when it's available
export const createPromiseWithResolvers = <T>(): PromiseWithResolvers<T> => {
  let resolve: (param: T | PromiseLike<T>) => void = _.noop;
  let reject: (reason?: any) => void = _.noop;
  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  return { promise, resolve, reject };
};
